const mixin = {
  data() {
    return {
      box: `<div class="box">
  Lorem ipsum dolor sit amet consectetur adipisicing elit. Maiores iure corporis dignissimos quaerat eveniet voluptatem a modi adipisci vel similique ea incidunt commodi ad reiciendis facilis necessitatibus possimus, eligendi tempore.
</div>`
    }
  }
}

export { mixin as boxMixin }
